import React from 'react';
import { Typography, Stack, Box } from '@mui/material';
import { SectionPaper } from '../../../../common/components/styled-ui-elements';
import { DescriptionEditor, FeeTypeEditor, CategoryEditor, FeeScheduleEffectiveDateEditor, FeeScheduleEndDateEditor, RevCodeRestrictionsEditor } from '../../fieldEditors/feeScheduleEditors';
import { ContractView } from '../../../../../services/ContractService/types/contractTypes';

interface FeeScheduleOverviewProps {
  contract?: ContractView;
}

const FeeScheduleOverview: React.FC<FeeScheduleOverviewProps> = ({ contract }) => {
  return (
    <SectionPaper>
      <Stack spacing={2}>
        {/* Contract Info Row */}
        {contract && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1.5, borderBottom: '1px solid #e2e8f0' }}>
            <Typography variant="h6" sx={{ color: '#62BCBD', fontWeight: 500 }}>
              {contract.payer}
            </Typography>
            <Typography variant="h6" sx={{ color: '#62BCBD', fontWeight: 500 }}>
              {contract.product}
            </Typography>
          </Box>
        )}

        {/* Top Row: Description */}
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          <DescriptionEditor />
        </Stack>

        {/* Second Row: Fee Type, Category, Effective Date, and End Date */}
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          <FeeTypeEditor />
          <CategoryEditor />
          <FeeScheduleEffectiveDateEditor />
          <FeeScheduleEndDateEditor />
        </Stack>

        {/* Third Row: Rev Code Restrictions */}
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          <RevCodeRestrictionsEditor />
        </Stack>
      </Stack>
    </SectionPaper>
  );
};

export default FeeScheduleOverview;
